module.exports = __webpack_public_path__ + "static/img/sch.5c564b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sch.jpg
// module id = adGt
// module chunks = 0